import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { extractCommonFormFields } from '../../../ai/common/extract-common-form-fields';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type TextFieldDefinition } from './text-field.definition';

export class TextFieldDefinitionMapper implements DefinitionMapper<'textField'> {
  readonly type = 'textField';

  extract(
    element: CanvasElementFrom<'textField'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'textField'>,
  ): PartialDeep<TextFieldDefinition> {
    const { input } = element.props.content;

    return {
      ...extractCommonFormFields(element),
      placeholder: input?.placeholder,
    };
  }
}
